define('controllers/executive/hotelinterest',['require','layout','johngrid','utils'],function(require) {
    'use strict';
    var layout = require('layout');
    var JohnGrid = require('johngrid');
    var utils = require('utils');
    return {
        load: function () {
            $.get('/api/hotels/getinterest').then(function (hotelInterest) {
                layout.initStatic('fe/templates/executive/hotel-interest').then(function() {
                    this.grids = [];
                    hotelInterest.individual.forEach(function (i) {
                        i.Created = utils.formatDate(i.Created, 'M/d/yyyy h:mm tt');
                    });
                    this.initGrid(hotelInterest.individual, 'tblIndividual');
                    this.initGrid(hotelInterest.hotel, 'tblHotel');
                    this.initGrid(hotelInterest.users, 'tblUsers');
                    this.setUpTabs();
                }.bind(this));
            }.bind(this));
        },

        setUpTabs: function () {
            this.$tabs = $('#vac_tabs a');
            this.$tabs.on('click', function (e) {
                var $this = $(this);
                $this.tab('show');
            });
        },

        initGrid: function (data, tableId) {
            var grid = new JohnGrid();
            grid.init($('#{0}'.format(tableId)));
            grid.databind(data);
            this.grids.push(grid);
        },

        unload: function() {
            if (this.grids != null) {this.grids.forEach(function (grid) { return grid.unload(); });}
            if (this.$tabs != null) {
                this.$tabs.off('click');
                this.$tabs = null;
            }
        }
    };
});

